// simulator/templates.js
import { fmtDT, safeDate } from './utils.js';

export function listItemTemplate(it, UPDATED_FIELD) {
    const uuid = it.uuid ?? it.id ?? '(no uuid)';
    const dt = safeDate(it[UPDATED_FIELD]);
    const updatedTxt = dt ? fmtDT(dt) : '—';
    const status = (it.status ?? '').toString().toLowerCase();
    const synced = typeof it.synced === 'boolean' ? (it.synced ? 'Yes' : 'No') : null;

    const stateBadge =
        status === 'invalid' || status === 'fake'
            ? '<span class="badge rounded-pill text-bg-danger ms-2">invalid</span>'
            : status
                ? '<span class="badge rounded-pill text-bg-success ms-2">ok</span>'
                : '';
    const syncedBadge =
        synced == null ? '' : `<span class="badge rounded-pill text-bg-${synced === 'Yes' ? 'success' : 'warning'} ms-2">synced: ${synced}</span>`;
    const scan_count = `<span class="scan_count text-primary fw-bold"> ${it.scan_count}</span>`;

    return `
    <li class="list-group-item">
      <div class="uuid">
        <span class="text-body-secondary">uuid</span>
        <code class="mono ms-2">${uuid}</code>
        ${stateBadge}
        <span class="text-primary ms-5 me-1 fw-bold">Scan count</span>
        ${scan_count}
        ${syncedBadge}
      </div>
      <div class="meta">
        <span class="me-1">updated_at</span>
        <time class="fw-medium">${updatedTxt}</time>
      </div>
    </li>
  `;
}
